
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import moment from 'moment';

import DictSelect from '../../ui/DictSelect';

const fields = [{
    "text": "竞价品名称",
    "field": "name",
    "disabled": true,
}, {
    "text": "竞价品编号",
    "field": "code",
    "disabled": true,
}, {
    "text": "起始价",
    "field": "startPrice",
    "disabled": true,
}, {
    "text": "最终价格",
    "field": "finalPrice",
    "disabled": true,
}, {
    "text": "中标商户",
    "field": "memberName",
    "disabled": true,
}, {
    "text": "服务费",
    "field": "serviceCharge",
    "number": true
}, {
    "text": "过户费",
    "field": "tradeCharge",
    "number": true
}, {
    "text": "到账日期",
    "field": "collectionDate",
    "date": true
}, {
    "text": "交接情况",
    "field": "handover",
    "select": true,
    "category": "AUCTION_HANDOVER",
    // "textarea": true,
    // rules: [
    //     { max: 128, message: '交接情况最多只能输入128个字符！' }
    // ]
}, {
    "text": "备注",
    "field": "remark",
    "textarea": true,
    rules: [
        { max: 128, message: '备注最多只能输入128个字符！' }
    ]
}];

class AuctionResultEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            if (values["collectionDate"] != null) {
                values["collectionDate"] = values["collectionDate"].format("YYYY-MM-DD");
            }
            http.post({
                url: '/auctionResult/saveLotsResult',
                data: values,
                success: (res) => {
                    // this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let domItem = "";
            domItem = (
                <Form.Item label={item.text + "："} key={i}>
                    {getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                            : editData[item.field],
                    })(
                        item.number ? <InputNumber min={0} max={999999999} precision={0} style={{ width: '100%' }} />
                            : item.date ? <DatePicker style={{ width: '100%' }} />
                                : item.select ? <DictSelect category={item.category} allowClear={true} />
                                    : item.textarea ? <Input.TextArea />
                                        : <Input disabled={item.disabled} />
                    )}
                </Form.Item>
            );
            dom.push(domItem);
        }
        return dom;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="竞价结果信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const AuctionResultEdit = Form.create()(AuctionResultEditForm);

export default AuctionResultEdit;